// extracted by mini-css-extract-plugin
module.exports = {"slider":"ImageSlider1_slider__3txbE","image":"ImageSlider1_image__2TGe6","right_arrow":"ImageSlider1_right_arrow__3VB8_","left_arrow":"ImageSlider1_left_arrow__2pZMz"};